import { render, staticRenderFns } from "./ProjektabschlussModal.vue?vue&type=template&id=703ce4c3&"
import script from "./ProjektabschlussModal.vue?vue&type=script&lang=js&"
export * from "./ProjektabschlussModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjektabschlussModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports